<ion-header #header>
    <ion-toolbar #toolbar>
        <ion-buttons slot="primary">
            <ion-button appClick (clicked)="onClose()" #menuButton id="mainmenu-menu-button">Abbrechen</ion-button>
        </ion-buttons>
        <ion-title><span id="page-title-span">{{ 'Verträge' | translate }}</span></ion-title>
    </ion-toolbar>
</ion-header>

<ion-content class="app-content">

    <ion-searchbar [(ngModel)]="suchtext"
                   (ionChange)="onSearchChanged($event)"
                   (ionCancel)="onSearchChanged($event)"
                   enterkeyhint="search"
                   [debounce]="1000"
                   placeholder="{{ 'Suchen' | translate }}"
                   #searchbar></ion-searchbar>

    <ion-refresher slot="fixed" (ionRefresh)="doRefresh($event)">
        <ion-refresher-content></ion-refresher-content>
    </ion-refresher>

    <cdk-virtual-scroll-viewport *ngIf="sichtbareItems.length" [itemSize]="48" minBufferPx="900" maxBufferPx="1350" class="ion-content-scroll-host">
        <ion-list>
            <div *cdkVirtualFor="let item of sichtbareItems; let index = index;">
                <ion-item class='artikelitem' appClick (clicked)="onItemSelected(item)">
                    <ion-label class="row-item-label">
                        <ion-icon *ngIf="item.istFavorit" name="star" class="favorit-icon"></ion-icon>
                        <h2>{{ item.vertrag.Abholadresse.Name1 }}</h2>
                        <div>{{ item.vertrag.Abholadresse.Name2 }}</div>
                        <div>{{ item.vertrag.Abholadresse.Strasse }}</div>
                        <div>{{ item.vertrag.Abholadresse.PLZ }} {{ item.vertrag.Abholadresse.Ort }}</div>
                        <div>Vertragsnummer: {{ item.vertrag.Vertragsnummer }}</div>
                        <div class="vtext">{{ item.vertrag.Text }}</div>
                    </ion-label>
                </ion-item>
            </div>
        </ion-list>
    </cdk-virtual-scroll-viewport>

</ion-content>